import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import type { PipelineStepId, PipelineStepState } from '../types';
import { PIPELINE_STEP_IDS } from '../types';
import {
  buildFriendlySummary,
  formatFriendlySummary,
  STEP_ACCENTS,
  statusLabelKey,
} from '../utils/step-display';

export function usePipelineStepOverview(
  steps: Record<PipelineStepId, PipelineStepState>,
  activeStepIndex: number,
) {
  const { t } = useTranslation('pipelineDebug');

  return useMemo(
    () =>
      PIPELINE_STEP_IDS.map((stepId, index) => {
        const summary = buildFriendlySummary(stepId, steps[stepId]);
        return {
          stepId,
          index,
          accent: STEP_ACCENTS[stepId],
          isActive: index === activeStepIndex,
          status: steps[stepId].status,
          statusLabelKey: statusLabelKey(steps[stepId].status),
          summary: formatFriendlySummary(summary, t),
        };
      }),
    [activeStepIndex, steps, t],
  );
}
